import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart_enrollment-create operation
 * @param params - Contains path parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const createCartEnrollment = async ({
  params,
  request,
}: {
  params: ApiTypes["cart_enrollment-create"]["parameters"]["path"];
  request: ApiTypes["cart_enrollment-create"]["request"];
}): Promise<ApiTypes["cart_enrollment-create"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["cart_enrollment-create"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/enrollment`,
      request,
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to createCartEnrollment: ${params.cart_token}",
    );
    throw error;
  }
};
